import script from "./CollectionImages.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionImages.vue?vue&type=script&setup=true&lang=js"

import "./CollectionImages.vue?vue&type=style&index=0&id=169236b3&lang=scss"

const __exports__ = script;

export default __exports__